import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/functions";
import "firebase/auth";
import "firebase/storage";
import "firebase/messaging";
const env = process.env.NODE_ENV || "development";

const config = {
  production: {
    apiKey: "AIzaSyAoJ6tiGuJwMceHP_7euxYUpix5kngVPpM",
    authDomain: "mobchowapp.firebaseapp.com",
    databaseURL: "https://mobchowapp.firebaseio.com",
    projectId: "mobchowapp",
    storageBucket: "mobchowapp.appspot.com",
    messagingSenderId: "585955132382",
    appId: "1:585955132382:web:22bb62d28327991d2cd34f",
    measurementId: "G-SCE2QSX6BJ",
  },
  development: {
    apiKey: "AIzaSyAF177_A3fEBHAwHKBNWX9JPZ_gFUBc3ME",
    authDomain: "cure-coffeehouse.firebaseapp.com",
    databaseURL: "https://cure-coffeehouse.firebaseio.com",
    projectId: "cure-coffeehouse",
    storageBucket: "cure-coffeehouse.appspot.com",
    messagingSenderId: "824335998087",
  },
};

const firebaseApp = firebase.initializeApp(config["production"]);

export default firebaseApp;



// WEBPACK FOOTER //
// ./src/firebase.js